module.exports = __webpack_public_path__ + "static/media/bookmark.42f1c671.svg";